module.exports = __webpack_public_path__ + "img/wf-finishing-position-6.d35bfa77.svg";